var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fx-date-range" },
    [
      _vm.presets && _vm.presets.length
        ? _c(
            "fx-select",
            {
              attrs: {
                value: _vm.selectedRangeOption,
                options: _vm.dateOptions,
                "default-option": { label: _vm.defaultOptionCopy, value: null },
                align: _vm.align,
                "disable-native": true
              },
              on: { input: _vm.onOptionSelected }
            },
            [
              _c(
                "template",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.value,
                      expression: "!value"
                    }
                  ],
                  slot: "caret"
                },
                [
                  _vm._t("caret", [
                    _c("span", { staticClass: "icon-caret-down" })
                  ])
                ],
                2
              )
            ],
            2
          )
        : _c(
            "div",
            {
              staticClass: "fx-custom-date-range-select",
              attrs: { tabindex: "0" },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  _vm.setCustomRangeOpen(!_vm.isCustomRangeOpen)
                },
                click: function($event) {
                  _vm.setCustomRangeOpen(!_vm.isCustomRangeOpen)
                }
              }
            },
            [
              _c("span", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.selectedRangeOption === "custom-range"
                        ? _vm.formattedDateRange || _vm.selectCustomRangeCopy
                        : _vm.defaultOptionCopy
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm.value
                ? _c("span", {
                    staticClass: "icon-cancel",
                    attrs: { tabindex: "0" },
                    on: {
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        return _vm.reset($event)
                      },
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.reset($event)
                      }
                    }
                  })
                : _vm._t("caret", [
                    _c("span", { staticClass: "icon-caret-down" })
                  ])
            ],
            2
          ),
      _vm._v(" "),
      _vm.isCustomRangeOpen
        ? _c(
            "div",
            {
              staticClass: "fx-date-picker--desktop",
              class: {
                "align-left": _vm.align === "left",
                "align-right": _vm.align === "right"
              }
            },
            [
              _c("fx-date", {
                directives: [
                  {
                    name: "on-click-outside",
                    rawName: "v-on-click-outside.static",
                    value: function() {
                      return _vm.setCustomRangeOpen(false)
                    },
                    expression: "() => setCustomRangeOpen(false)",
                    modifiers: { static: true }
                  }
                ],
                attrs: {
                  "max-date": _vm.maxDate,
                  "min-date": _vm.minDate,
                  value: null,
                  mode: "range"
                },
                on: { input: _vm.onCustomRangeSelected }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }